import React from "react";
import {
  FontWeights,
  getTheme,
  IButtonStyles,
  IconButton,
  IIconProps,
  IModalProps,
  mergeStyleSets,
  Modal,
} from "@fluentui/react";

const theme = getTheme();
const contentStyles = mergeStyleSets({
  header: [
    theme.fonts.xLarge,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 0px",
    },
  ],
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
  },
});

const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginTop: "4px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

const backIcon: IIconProps = { iconName: "ChevronLeftMed" };

export interface FullPageModalProps {
  modalProps?: Omit<IModalProps, "children">;
  onClose: () => void;
  textTitle: string;
  children: IModalProps["children"];
}

export const FullPageModal: React.FunctionComponent<FullPageModalProps> = ({
  onClose,
  textTitle,
  children,
  modalProps,
}) => {
  return (
    <Modal
      titleAriaId={"titleId"}
      isBlocking={false}
      containerClassName={contentStyles.container}
      styles={{
        main: {
          minHeight: "100%",
          minWidth: "100%",
        },
      }}
      {...modalProps}
    >
      <div className={contentStyles.header}>
        <IconButton
          styles={iconButtonStyles}
          iconProps={backIcon}
          ariaLabel="Close popup modal"
          onClick={() => onClose()}
        />
        <span id={"titleId"} data-testid="modal-title">
          {textTitle}
        </span>
      </div>
      <div>{children}</div>
    </Modal>
  );
};
